import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import { UNPROCESSABLE_ENTITY } from '@mm/constants/status-codes';
import { permissionsHandler, ResponseOrError } from './common-handler';
import { openCustomAudienceErrorModal } from '../modules/modalsState/actions';
import { getErrorJson } from '@mm/utils';
import CrudActionContainer from '../actions/CrudActionContainer';

export default (
    dispatch: Dispatch<StoreState>,
    container: CrudActionContainer,
  ) =>
  async (error: ResponseOrError) => {
    if (error instanceof Response && error.status === UNPROCESSABLE_ENTITY) {
      const errors = await getErrorJson(error);
      dispatch(openCustomAudienceErrorModal(errors && errors.errors));
    } else {
      permissionsHandler(dispatch, container)(error);
    }
  };
